import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { doMappingUpdated } from 'src/containers/ProjectDiagram/utils/mapping/doMappingUpdated';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

/** sets `uniqueKeySets` on Mapping */
export const updateMappingUniqueKeySets =
  ({ key, uniqueKeySets }: { key: string; uniqueKeySets: string[] }) =>
  (model: Model) => {
    const mapping = model.linkDataArray.find(
      (linkData): linkData is Mapping =>
        isMapping(linkData) && linkData.key === key
    );
    if (!mapping) {
      return;
    }

    setDataProperty<Mapping>(model)(mapping, 'uniqueKeySets', uniqueKeySets);

    doMappingUpdated(mapping)(model);
  };
